import { Injectable } from "@angular/core";
import { GAService } from "projects/core/app/services/ga.service";
import { CacheService } from "projects/core/app/services/cache.service";
import { LocationService } from "projects/core/app/services/location.service";
import { FeatureFlagsService } from "projects/core/app/services/feature-flags.service";
import { NavigationService } from "projects/core/app/services/navigation.service";
import { CachedHttpService } from "projects/core/app/services/cached-http.service";
import { LocalisationService } from "projects/core/app/services/localisation.service";
import { ConciergeDataService } from "../concierge-data.service";
import Bugsnag from "@bugsnag/js";
import { BaseCommonService } from "projects/core/app/services/abstracts/common.service";
import { BaseBrandService } from "projects/core/app/services/abstracts/brand.service";
import { BasePatientsService } from "projects/core/app/services/abstracts/patients.service";
import { BaseAuthService } from "projects/core/app/services/abstracts/auth.service";
@Injectable({
  providedIn: "root",
})
export class ConciergeCommonService extends BaseCommonService {
  constructor(
    _brandService: BaseBrandService,
    _patientsService: BasePatientsService,
    _authService: BaseAuthService,
    _gaService: GAService,
    _cacheService: CacheService,
    _locationService: LocationService,
    _featureFlagsService: FeatureFlagsService,
    _navigationService: NavigationService,
    _cachedHttpService: CachedHttpService,
    _localisationService: LocalisationService,
    private _conciergeDataService: ConciergeDataService
  ) {
    super(
      _brandService,
      _patientsService,
      _authService,
      _gaService,
      _cacheService,
      _locationService,
      _featureFlagsService,
      _navigationService,
      _cachedHttpService,
      _localisationService
    );
  }

  protected _handleDomainInfo302(graphData: any, _pathname: string): void {
    this._conciergeDataService.setConciergeDataSiteUrl(`https://${graphData.redirect_uri}`);
    window.location.reload();
  }

  protected _handleDomainInfo404(graphData: any): void {
    super._handleDomainInfo404(graphData);

    Bugsnag.notify("Error getting brand info on pair domain, deleting Concierge data and navigating to pair");
    this._conciergeDataService.deleteConciergeData();
    this._navigationService.navigate("pair");
  }

  protected _handleDomainInfo200(graphData: any, pathname: string): void {
    this._authService.setPublicToken(graphData.public_jwt);
    super._handleDomainInfo200(graphData, pathname);
  }

  protected get allowAutocomplete(): boolean {
    return false;
  }
}
